export function WipBanner() {
  const linkClass =
    "text-[var(--text-muted)] transition-colors duration-200 hover:text-[var(--accent)] focus:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--accent)] rounded-sm";
  return (
    <div
      role="status"
      aria-live="polite"
      className="rl-hero-glass text-[var(--text-secondary)] text-center text-sm"
      style={{
        borderRadius: "var(--radius-sm)",
        padding: "0.5rem 1rem",
        marginBottom: "1rem",
      }}
    >
      <span>
        Work in Progress: Diese Seite wird noch aufgebaut. Feedback und Rückfragen gerne an{" "}
        <a
          href="mailto:Contact@RestLicht.FYI"
          className={linkClass}
          style={{ textDecoration: "underline", textUnderlineOffset: 2 }}
        >
          Contact@RestLicht.FYI
        </a>
      </span>
      <span
        style={{
          display: "block",
          color: "var(--text-muted)",
          fontSize: "0.75rem",
          marginTop: "0.25rem",
        }}
      >
        Work in progress: this site is still being built. Feedback and questions welcome at{" "}
        <a
          href="mailto:Contact@RestLicht.FYI"
          className={linkClass}
          style={{ textDecoration: "underline", textUnderlineOffset: 2 }}
        >
          Contact@RestLicht.FYI
        </a>
      </span>
    </div>
  );
}
